/* eslint-disable global-require */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster/dist/MarkerCluster.css';
import 'leaflet.markercluster/dist/MarkerCluster.Default.css';
import * as L from 'leaflet';
import 'leaflet.markercluster';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import shadowMarker from 'leaflet/dist/images/marker-shadow.png';
import iconRetinaUrl from 'leaflet/dist/images/marker-icon-2x.png';
import iconUrl from 'leaflet/dist/images/marker-icon.png';
import {
  getLocationName, getCompletedControlLabel,
} from '../../utils';
import redMarker from './icons/marker-red.svg';
import redDoneMrker from './icons/marker-red-done.svg';
import turquoiseMarker from './icons/marker-turquoise.svg';
import turquoiseDoneMarker from './icons/marker-turquoise-done.svg';
import blackMarker from './icons/marker-black.svg';
import blackDoneMarker from './icons/marker-black-done.svg';
import myLocation from './icons/my-location.svg';

// eslint-disable-next-line no-underscore-dangle
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl,
  iconUrl,
  shadowUrl: shadowMarker,
});

const myLocationIcon = L.icon({
  iconUrl: myLocation,
  iconSize: [20, 20], // size of the icon
  iconAnchor: [10, 10], // point of the icon which will correspond to marker's location
});

const skjenkIcon = L.icon({
  iconUrl: redMarker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const skjenkDoneIcon = L.icon({
  iconUrl: redDoneMrker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const salgIcon = L.icon({
  iconUrl: turquoiseMarker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const salgDoneIcon = L.icon({
  iconUrl: turquoiseDoneMarker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const tobaccoIcon = L.icon({
  iconUrl: blackMarker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

const tobaccoDoneIcon = L.icon({
  iconUrl: blackDoneMarker,
  shadowUrl: shadowMarker,
  iconSize: [40, 40], // size of the icon
  shadowSize: [40, 40], // size of the shadow
  iconAnchor: [20, 40], // point of the icon which will correspond to marker's location
  shadowAnchor: [15, 40],
  popupAnchor: [0, -40],
});

let map = null;
let markers = null;
let myLocationMarker = null;
let myLocationCircle = null;

function locate() {
  if (map != null) {
    map.locate({ setView: false, maxZoom: 16, enableHighAccuracy: true });
    if (myLocationMarker == null && myLocationCircle == null) {
      myLocationMarker = L.marker([0, 0], { icon: myLocationIcon }).addTo(map);
      myLocationCircle = L.circle([0, 0], 0).addTo(map);
    }
  }
}

function onLocationFound(e) {
  myLocationMarker.setLatLng(e.latlng);
  myLocationCircle.setLatLng(e.latlng);
  myLocationCircle.setRadius(e.accuracy);
}

function addLocationMarkers(licenses, workPlan, showWorkPlanLicenses, translate) {
  markers = L.markerClusterGroup();

  licenses.map((license) => {
    const title = getLocationName(license);

    let completedControlLabel = '';
    if (showWorkPlanLicenses) {
      completedControlLabel = getCompletedControlLabel(true, workPlan, null, license.sysId);
    }
    const isControlCompleted = completedControlLabel === 'Ja';

    const { lat, lon } = license.location.address.coordinates;
    if (lat && lon) {
      let icon = isControlCompleted ? tobaccoDoneIcon : tobaccoIcon;
      if (license.licenseType === 'skjenk' || license.licenseType === 'ea-skjenk') {
        icon = isControlCompleted ? skjenkDoneIcon : skjenkIcon;
      } else if (license.licenseType === 'salg' || license.licenseType === 'ea-salg') {
        icon = isControlCompleted ? salgDoneIcon : salgIcon;
      }

      const marker = L.marker(
        new L.LatLng(
          license.location.address.coordinates.lat,
          license.location.address.coordinates.lon,
        ),
        { title, icon },
      );

      const completedControl = showWorkPlanLicenses
        ? `<br>${translate('license.completedControl')}: ${completedControlLabel}` : '';

      let controlZone = '(ikke plassert i sone ennå)';
      if (license.controlZone) {
        controlZone = `${(license.controlZone.indexOf('sone') === 0) ? license.controlZone.substring(4) : license.controlZone}`;
      }

      marker.bindPopup(
        `<a href="${window.location.origin}/#/${license.sysId}"><b>${getLocationName(license)}</b><br>`
                + `Bevillingstype: ${license.licenseType}<br>`
                + `Bevillingshaver: ${license.licensee.name}<br>`
                + `Kontrollsone: ${controlZone}`
                + `${completedControl}</a>`,
      );
      markers.addLayer(marker);
    }
    return true;
  });

  map.addLayer(markers);
  return map;
}

class Map extends Component {
  constructor(props) {
    super(props);
    this.state = {
      intervalId: undefined,
    };
  }

  componentDidMount() {
    const {
      licenses, workPlan, showWorkPlanLicenses, translate,
    } = this.props;

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 18,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    });
    const latlng = L.latLng(63.4305, 10.3951);

    map = L.map('map', {
      center: latlng, zoom: 13, tap: false, layers: [tiles],
    });

    addLocationMarkers(licenses, workPlan, showWorkPlanLicenses, translate);

    locate();
    const int = setInterval(locate, 3000); // update location marker every 3 seconds
    this.setState({ intervalId: int });

    map.on('locationfound', onLocationFound);
    map.on('locationerror', this.onLocationError);
  }

  componentDidUpdate() {
    const {
      licenses, workPlan, showWorkPlanLicenses, translate,
    } = this.props;
    map.removeLayer(markers);
    addLocationMarkers(licenses, workPlan, showWorkPlanLicenses, translate);
  }

  componentWillUnmount() {
    const { intervalId } = this.state;
    map = null;
    myLocationMarker = null;
    myLocationCircle = null;
    if (intervalId) clearInterval(intervalId);
  }

  onLocationError = (e) => {
    const { intervalId } = this.state;
    if (intervalId) clearInterval(intervalId);
    if (e.message != null && e.message.toLowerCase().indexOf('user denied geolocation') >= 0) {
      // eslint-disable-next-line no-alert
      alert('Tilgang til geolokasjon er avslått. Du vil ikke se din posisjon i kartet.');
    } else {
      // eslint-disable-next-line no-console
      console.error(e.message);
    }
  }

  render() {
    const { classes } = this.props;
    return (
      <div id="map" className={classes.map} />
    );
  }
}

const styles = () => ({
  map: {
    position: 'relative',
    maxWidth: '68.5rem',
    zIndex: 0,
    height: '100%',
  },
});

Map.defaultProps = {
  workPlan: null,
};

Map.propTypes = {
  classes: PropTypes.object.isRequired,
  licenses: PropTypes.array.isRequired,
  workPlan: PropTypes.object,
  showWorkPlanLicenses: PropTypes.bool.isRequired,
  translate: PropTypes.any.isRequired,
};

const mapStateToProps = ({ localize }) => ({
  translate: getTranslate(localize),
});

export default connect(mapStateToProps)(withStyles(styles)(Map));
